import { Phone, Loader2 } from "lucide-react";
import { COMPANY, useSiteContent } from "../../lib/api";

export function QuoteForm({ compact = false, id = "quote" }) {
  const content = useSiteContent();
  const bookingUrl = content?.booking_url || "";

  return (
    <div id={id} data-testid="quote-form" className={`bg-white rounded-3xl border border-black/5 shadow-xl overflow-hidden ${compact ? "p-4" : "p-5 md:p-6"}`}>
      {!compact && (
        <div className="mb-4 px-1">
          <h3 className="font-display font-extrabold text-2xl text-[#1A2421]">Get a free quote</h3>
          <p className="text-[#4A5550] text-sm mt-1">No obligation. Tell us about your job and we'll be in touch.</p>
        </div>
      )}

      {bookingUrl ? (
        <div className="relative w-full rounded-2xl overflow-hidden bg-[#F8F9FA]">
          <div className="absolute inset-0 grid place-items-center pointer-events-none">
            <Loader2 size={26} className="animate-spin text-[#62B848]" />
          </div>
          <iframe
            data-testid="quote-servicem8-iframe"
            title="Request a booking — West Face Roofing"
            src={bookingUrl}
            className="relative w-full border-0 bg-transparent"
            style={{ height: compact ? "620px" : "720px" }}
            loading="lazy"
          />
        </div>
      ) : (
        <div data-testid="quote-form-fallback" className="rounded-2xl bg-[#F8F9FA] p-8 text-center">
          <p className="text-[#4A5550] mb-4">Our online quote form is being set up. Give us a call and we'll sort your roof.</p>
          <a href={COMPANY.phoneHref} className="inline-flex items-center gap-2 bg-[#224733] text-white font-bold px-6 py-3 rounded-full">
            <Phone size={16} /> {COMPANY.phone}
          </a>
        </div>
      )}

      <p className="text-center text-xs text-[#4A5550] mt-4">Prefer to talk? Call <a href={COMPANY.phoneHref} className="font-bold text-[#224733]">{COMPANY.phone}</a></p>
    </div>
  );
}
